'use strict';

import { BaseController } from '../../../base/controller';
import escapeStringRegexp from 'escape-string-regexp';

export class PasswordFormController extends BaseController {
  constructor($scope, controllerService) {
    'ngInject';
    super({ $scope, controllerService });
  }

  get passwordRequired() {
    return this.mandatory || this.withPassword;
  }

  $onInit() {
    this.messages = {
      required: 'app.password.required',
      pattern: 'app.password.pattern'
    };
    this.$scope.$watchGroup(['vm.withPassword', 'vm.password', 'vm.confirmPassword'], () => {
      this.passwordInputChanged();
    });
  }

  passwordInputChanged() {
    if (this.password) {
      this.passwordFormOptions = {
        pattern: new RegExp(`^${escapeStringRegexp(this.password)}$`, 'g')
      };
    }
    this.passwordChanged();
  }

  passwordChanged() {
    if (!this.onChange) {
      return;
    }

    if (!this.passwordRequired) {
      return this.onChange({ checked: false, password: null });
    }

    const { password } = this;
    if (this.form.$valid && password) {
      this.onChange({ checked: true, password });
    }
  }
}
